<template>
  <div>
    <el-card>
      <div slot="header" class="nationalmanage-header">
        <span>国补支持地区</span>
        <el-button type="primary" size="medium" @click="onAddArea">添加地区</el-button>
      </div>
      <el-tag
        v-for="(tag, idx) in tagsList"
        :key="idx"
        @close="handleClose(tag)"
        closable>
        {{tag}}
      </el-tag>

    </el-card>
    <el-card>
      <div slot="header">国补支持门店及品类</div>
      <SpFinder
        ref="finder"
        row-key="id"
        :split-count="10"
        :url="table_url"
        :setting="setting"
        fixed-row-action
        reserve-selection
        :hooks="{
          beforeSearch
        }"
      >
        <template slot="tableTop">
          <el-button type="primary" size="medium" @click="addUnionPayConfig">添加门店</el-button>
          <ImportDialog
            ref="importDialog"
            buttonName="批量导入"
            buttonSize="medium"
            fileName="批量导入"
            fileType="upload_gov_subsidy_distributor_items"
          />
          <el-button type="primary" size="medium" @click="deleteUnionPayConfig">批量删除</el-button>
        </template>
      </SpFinder>
    </el-card>
  </div>
</template>
<script>
import { useDialog } from '@shopex/finder'
import ImportDialog from '@/components/importDialog'
import { tableSetting } from './config'
import { List, saveGovArea, getGovSettingArea, batchAearDelete, updategovStatus, setGovItems, batchDelete, updategovSettingStatus } from './api'

export default {
  components: {
    ImportDialog
  },
  computed: {
    setting() {
      return tableSetting(this)
    }
  },
  data () {
    return {
      table_url: List,
      tagsList: [],
    }
  },
  mounted() {
    this.getAreaList()
  },
  methods: {
    beforeSearch (params) {
      params = {
        ...params,
        page_size: params.pageSize,
        ...this.formData
      }
      return params
    },
    refresh() {
      this.$refs.finder.refresh()
      this.getAreaList()
    },
    onAddArea () {
      useDialog('null', {
        title: '请选择国补地区',
        width: '600px',
        component: () => import('./comps/createArea'),
        actions: [
          { label: '取消', key: 'close', size: 'default' },
          { label: '保存', key: 'save', type: 'primary', size: 'default' }
        ]
      }).then(async (area) => {
        if (area.length == 0) return
        await saveGovArea({ area })
        this.$message.success('保存成功')
        this.getAreaList()
      })
    },
    async handleClose (tag) {
      await batchAearDelete(tag).then(res => {
        this.$message.success('删除成功')
        this.getAreaList()
      })
    },
    async getAreaList () {
      const data = await getGovSettingArea()
      console.log(data.data.data.area)
      this.tagsList = data.data.data.area
    },
    addUnionPayConfig () {
      useDialog(null, {
        title: `新增国补支持店铺及品类`,
        width: '30%',
        component: () => import('./comps/createForm.vue'),
        actions: [
          { label: '取消', key: 'close', size: 'default' },
          { label: '提交', key: 'save', type: 'primary', size: 'default' }
        ]
      }).then(async (arg) => {
        if(arg) {
          console.log(arg, this.$refs.form, 'add_arg')
          try {
            await setGovItems(arg)
            this.$message.success('新增成功')
            this.refresh()
          } catch (error) {
            console.log(error)
          }
        }
      })
    },
    deleteUnionPayConfig () {
      const selection = this.$refs.finder.$refs.finderTable.getSelection()
      if (selection.length === 0) return this.$message.error('请选择需要删除的数据')
      this.$confirm('请确认是否批量删除？', '提示').then(async () => {
        const distributor_info = selection.map(v => {
          return {
            distributor_id: v.distributor_id,
            subsidy_type: v.subsidy_type
          }
        })
        await batchDelete({ distributor_info })
        this.$message.success('删除成功')
        this.refresh()
      })
    },
    async handleSettingChange (row) {
      console.log(row, 'row')
      await updategovSettingStatus({
        distributor_id: row.distributor_id,
        subsidy_type: row.subsidy_type == 1 ? 'online' : 'offline',
        open_status: row.open_status == 1 ? 2 : 1
      })
      this.refresh()
    },
    showGoods (row, subsidy_type) {
      console.log(row, 'row')
      useDialog(null, {
        title: `查看商品列表`,
        width: '70%',
        component: () => import('./comps/goodList.vue'),
        data: {
          distributor_id: row.distributor_id,
          subsidy_type: subsidy_type
        },
        actions: []
      })
    }
  }
}
</script>

<style scoped lang="scss">
.nationalmanage-header {
  display: flex;
  justify-content: space-between;
  align-items: center
}
</style>
<style lang="scss">

</style>

